/**
 * Fixed profession color palette — DATA, not styling. These are the exact
 * swatch values Trusstor's own profession color picker offers
 * (`professionBackgroundColorToWorkplanChipColorMappings` in
 * trusstor_dashboard); the picked hex is persisted upstream on the profession
 * record and round-trips back through the catalog API, so they cannot be CSS
 * tokens (the tokens.css hex rule governs UI styling, not upstream payloads).
 */
export const PROFESSION_PALETTE: readonly string[] = [
  '#4d0068', // space cadet
  '#004fc6', // azure
  '#4e9fe5', // blue sky
  '#cf2d71', // beetroot purple
  '#a5398d', // fandango
  '#b990c2', // african violet
  '#d260e1', // fresh purple
  '#f8839f', // pink sherbet
  '#ffa253', // orange
  '#14a4a4', // light sea green
  '#19cbdc', // supreme turquoise
  '#98001b', // cerise
];
